import { IFiservResponse } from '../store/interface';
import { getFromSessionStorage, setToSessionStorage } from '../store/storage';

export interface ISESSION_DATA {
  BROKER_AUTOPAY_PAYMENT_METHOD?: string;
  MEMBER_ID?: string; //used to retreive member bills and to pass as header
  SELECTED_CIM?: string; //used to decide selected bill from list of bills and to pass as header
  PAYMENT_AMOUNT?: string; // used to prepopulate amount selected by user after making payment on Make a payment screen
  PAYMENT_TYPE?: string; // used to prepopulate radio option selection (current amount, minimum due, other amount) after making payment on Make a payment screen
  MPP_ID?: string; //mppid from validate api response. used to pass as header
  SELECTED_CASE?: string; //used to decide selected bill from list of bills and  to pass as header
  PAYMENT_FUNDING_ACCOUNT_LAST_FOUR_DIGIT?: string; //last four digits of account used while making payment. Used in API call to send email confirmation
  PAYMENT_FUNDING_ACCOUNT_TOKEN?: string; // used in request body of immediate API call
  MEMBER_PAYMENT_METHOD?: string; // used for payment method display purpose on Review, Payment Confirmation screen
  PAYMENT_METHOD?: string; //used for payment method in makePayment
  PAYMENT_CONFIRMATION_NUMBER?: string; //used for confirmation number display purpose on Confirmation screen
  PAYMENT_DATE_TIMESTAMP?: string; // used in API call to send email confirmation
  SELECTED_PAYMENT_METHOD?: string; // used in immediate payment API call header
  SELECTED_WALLET_FUNDING_LAST_FOUR_DIGIT?: string; //used on wallets pages
  SELECTED_WALLET_FUNDING_ACCOUNT_TOKEN?: string; //used on wallets pages
  SELECTED_ADD_WALLET_TYPE?: string; //used to store the selected wallet type for adding a new payment method
  WALLET_FUNDING_ACCOUNT_TOKEN?: string; //wallet funding account in make Payment
  SELECTED_SCHEDULED_TRANSACTION?: string; // used on view scheduled transaction page to store the selected scheduled transaction for edit and cancel
  PAYMENT_DATE?: string; // used in review payments page to store the date for active users
  PAYMENT_API?: string; // used to retrieve the flow user is following for scheduled transaction IMMEDIATE/UPDATED/SCHEDULED/CANCELED
  ADD_TO_WALLET?: string; // used to store the value the user selected on make-payments page for the user consent to store the payment details in wallet
  M_ID?: string; //used to retreive email from backend
  ACCESS_TOKEN?: string; // used for calling apis for active members
  REFRESH_TOKEN?: string; // used for refreshing the access token
  PKCE_VERIFIER?: string; // random string to verify the api calls for access token are valid
  USER_TYPE?: string; // used for user type (active / guest)
  PKCE_STATE?: string; // used for state for pkce active member flow
  ACCESS_TOKEN_EXPIRY_TIME?: string; // used to signal when the access token needs to be refreshed, stores epoch
  USER_NAME?: string; // used for username of the member
  ORIGIN?: string; // used for BAM and publicSite differentiation
  ID_TOKEN?: string; // used for MMA users to store ID token
  BINDER_PAY_NOW_MEMBER_DETAILS?: string;
  SELECTED_TAB?: string; //used for storing the selectec tab value/route for BAM user
  BINDER_PAYMENT_ACCOUNT?: string;
  AUTOPAY_BINDER_PAYMENT_ACCOUNT?: string;
  BINDER_PAYLATER_LOGIN_DETAILS?: string;
  BINDER_IMMEDIATE_PAYMENT_RESPONSE?: string;
  BINDER_SCHEDULE_PAYMENT_RESPONSE?: string;
  BINDER_PAYMENT_DETAILS?: string;
  MEMBER_SUBSCRIBER_DETAILS?: string;
  BINDER_PAYMENT_API_TYPE?: string;
  AUTOPAYMENT_DETAILS?: string;
  SCHEDULEPAYMENTS_LIST?: string;
  PAY_NOW_CONFIRMATION_NUMBER?: string;
  READ_ONLY_VIEW?: string; // used for storing read only value.
  LIMIT_FUNCTIONALITY?: string; // used to store flag value to limit user experience
  CAID?: string;
  CONVERSION_TYPE_DETAILS?: string;
  SELECTED_RECENT_PAYMENT_TRACKER?: string;
  LOB?: string;
  MENU_ITEMS_CONFIGURATION?: string;
  POLICY_ID?: string;
  PLAN_SELECTED?: string;
  SELECTED_PRODUCT?: string;
  RETAIL_GOVT_DETAILS?: string;
  HAS_GOVT_SCHEDULE_PAYMENTS_INDICATOR?: string;
  SCHEDULE_PAYMENT_COUNT?: string;
  BROKER_FUNDING_ACCOUNT_DETAILS?: string;
  EMAIL_CONFIRMATION_STATUS?: string;
  BROKER_REFERENCE_CODE?: string;
  FORMATED_DATE?: string;
  IS_NMA_USER?: string;
  IS_BROKER_USER?: string;
  SELECTED_MEDICARE_PRODUCT?: string; // used to store selected Medicare product (part-d, advantage, supplement)
  HEALTHSPRING_PRODUCTS?: string; // used to persist healthspring products across full page redirect
}

export const SESSION_DATA: ISESSION_DATA = {
  MEMBER_ID: 'MEMBER_ID',
  BROKER_AUTOPAY_PAYMENT_METHOD: 'BROKER_AUTOPAY_PAYMENT_METHOD',
  SELECTED_CIM: 'SELECTED_CIM',
  PAYMENT_AMOUNT: 'PAYMENT_AMOUNT',
  PAYMENT_TYPE: 'PAYMENT_TYPE',
  MPP_ID: 'MPP_ID',
  MEMBER_SUBSCRIBER_DETAILS: 'MEMBER_SUBSCRIBER_DETAILS',
  SELECTED_CASE: 'SELECTED_CASE',
  PAYMENT_API: 'PAYMENT_API',
  PAYMENT_FUNDING_ACCOUNT_LAST_FOUR_DIGIT:
    'PAYMENT_FUNDING_ACCOUNT_LAST_FOUR_DIGIT',
  PAYMENT_FUNDING_ACCOUNT_TOKEN: 'PAYMENT_FUNDING_ACCOUNT_TOKEN',
  MEMBER_PAYMENT_METHOD: 'MEMBER_PAYMENT_METHOD',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  PAYMENT_CONFIRMATION_NUMBER: 'PAYMENT_CONFIRMATION_NUMBER',
  PAYMENT_DATE_TIMESTAMP: 'PAYMENT_DATE_TIMESTAMP',
  WALLET_FUNDING_ACCOUNT_TOKEN: 'WALLET_FUNDING_ACCOUNT_TOKEN',
  SELECTED_WALLET_FUNDING_LAST_FOUR_DIGIT:
    'SELECTED_WALLET_FUNDING_LAST_FOUR_DIGIT',
  SELECTED_WALLET_FUNDING_ACCOUNT_TOKEN:
    'SELECTED_WALLET_FUNDING_ACCOUNT_TOKEN',
  SELECTED_PAYMENT_METHOD: 'SELECTED_PAYMENT_METHOD',
  SELECTED_ADD_WALLET_TYPE: 'SELECTED_ADD_WALLET_TYPE',
  SELECTED_SCHEDULED_TRANSACTION: 'SELECTED_SCHEDULED_TRANSACTION',
  PAYMENT_DATE: 'PAYMENT_DATE',
  ADD_TO_WALLET: 'ADD_TO_WALLET',
  M_ID: 'M_ID',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  PKCE_VERIFIER: 'PKCE_VERIFIER',
  USER_TYPE: 'USER_TYPE',
  PKCE_STATE: 'PKCE_STATE',
  ACCESS_TOKEN_EXPIRY_TIME: 'ACCESS_TOKEN_EXPIRY_TIME',
  USER_NAME: 'USER_NAME',
  ORIGIN: 'ORIGIN',
  ID_TOKEN: 'ID_TOKEN',
  BINDER_PAY_NOW_MEMBER_DETAILS: 'BINDER_PAY_NOW_MEMBER_DETAILS',
  SELECTED_TAB: 'SELECTED_TAB',
  BINDER_PAYMENT_ACCOUNT: 'BINDER_PAYMENT_ACCOUNT',
  AUTOPAY_BINDER_PAYMENT_ACCOUNT: 'AUTOPAY_BINDER_PAYMENT_ACCOUNT',
  BINDER_PAYLATER_LOGIN_DETAILS: 'BINDER_PAYLATER_LOGIN_DETAILS',
  BINDER_IMMEDIATE_PAYMENT_RESPONSE: 'BINDER_IMMEDIATE_PAYMENT_RESPONSE',
  BINDER_SCHEDULE_PAYMENT_RESPONSE: 'BINDER_SCHEDULE_PAYMENT_RESPONSE',
  BINDER_PAYMENT_DETAILS: 'BINDER_PAYMENT_DETAILS',
  BINDER_PAYMENT_API_TYPE: 'BINDER_PAYMENT_API_TYPE',
  AUTOPAYMENT_DETAILS: 'AUTOPAYMENT_DETAILS',
  SCHEDULEPAYMENTS_LIST: 'SCHEDULEPAYMENTS_LIST',
  PAY_NOW_CONFIRMATION_NUMBER: 'PAY_NOW_CONFIRMATION_NUMBER',
  READ_ONLY_VIEW: 'READ_ONLY_VIEW',
  LIMIT_FUNCTIONALITY: 'LIMIT_FUNCTIONALITY',
  CAID: 'CAID',
  CONVERSION_TYPE_DETAILS: 'CONVERSION_TYPE_DETAILS',
  SELECTED_RECENT_PAYMENT_TRACKER: 'SELECTED_RECENT_PAYMENT_TRACKER',
  LOB: 'LOB',
  MENU_ITEMS_CONFIGURATION: 'MENU_ITEMS_CONFIGURATION',
  POLICY_ID: 'POLICY_ID',
  PLAN_SELECTED: 'PLAN_SELECTED',
  SELECTED_PRODUCT: 'SELECTED_PRODUCT',
  RETAIL_GOVT_DETAILS: 'RETAIL_GOVT_DETAILS',
  HAS_GOVT_SCHEDULE_PAYMENTS_INDICATOR: 'HAS_GOVT_SCHEDULE_PAYMENTS_INDICATOR',
  SCHEDULE_PAYMENT_COUNT: 'SCHEDULE_PAYMENT_COUNT',
  BROKER_FUNDING_ACCOUNT_DETAILS: 'BROKER_FUNDING_ACCOUNT_DETAILS',
  EMAIL_CONFIRMATION_STATUS: 'EMAIL_CONFIRMATION_STATUS',
  BROKER_REFERENCE_CODE: 'BROKER_REFERENCE_CODE',
  FORMATED_DATE: 'FORMATED_DATE',
  IS_NMA_USER: 'IS_NMA_USER',
  IS_BROKER_USER: 'IS_BROKER_USER',
  SELECTED_MEDICARE_PRODUCT: 'SELECTED_MEDICARE_PRODUCT',
  HEALTHSPRING_PRODUCTS: 'HEALTHSPRING_PRODUCTS',
};

export const getSessionData = (): ISESSION_DATA => {
  return {
    EMAIL_CONFIRMATION_STATUS: getFromSessionStorage(
      SESSION_DATA.EMAIL_CONFIRMATION_STATUS + '',
    ),
    BROKER_REFERENCE_CODE: getFromSessionStorage(
      SESSION_DATA.BROKER_REFERENCE_CODE + '',
    ),
    FORMATED_DATE: SESSION_DATA.FORMATED_DATE + '',
    BROKER_FUNDING_ACCOUNT_DETAILS: getFromSessionStorage(
      SESSION_DATA.BROKER_FUNDING_ACCOUNT_DETAILS + '',
    ),
    BROKER_AUTOPAY_PAYMENT_METHOD: getFromSessionStorage(
      SESSION_DATA.BROKER_AUTOPAY_PAYMENT_METHOD + '',
    ),
    MEMBER_ID: getFromSessionStorage(SESSION_DATA.MEMBER_ID + ''),
    SELECTED_CIM: getFromSessionStorage(SESSION_DATA.SELECTED_CIM + ''),
    PAYMENT_AMOUNT: getFromSessionStorage(SESSION_DATA.PAYMENT_AMOUNT + ''),
    PAYMENT_API: getFromSessionStorage(SESSION_DATA.PAYMENT_API + ''),
    PAYMENT_TYPE: getFromSessionStorage(SESSION_DATA.PAYMENT_TYPE + ''),
    MPP_ID: getFromSessionStorage(SESSION_DATA.MPP_ID + ''),
    PAYMENT_FUNDING_ACCOUNT_LAST_FOUR_DIGIT: getFromSessionStorage(
      SESSION_DATA.PAYMENT_FUNDING_ACCOUNT_LAST_FOUR_DIGIT + '',
    ),
    PAYMENT_DATE: getFromSessionStorage(SESSION_DATA.PAYMENT_DATE + ''),
    ADD_TO_WALLET: getFromSessionStorage(SESSION_DATA.ADD_TO_WALLET + ''),
    M_ID: getFromSessionStorage(SESSION_DATA.M_ID + ''),
    PAYMENT_FUNDING_ACCOUNT_TOKEN: getFromSessionStorage(
      SESSION_DATA.PAYMENT_FUNDING_ACCOUNT_TOKEN + '',
    ),
    MEMBER_PAYMENT_METHOD: getFromSessionStorage(
      SESSION_DATA.MEMBER_PAYMENT_METHOD + '',
    ),
    PAYMENT_METHOD: getFromSessionStorage(SESSION_DATA.PAYMENT_METHOD + ''),
    PAYMENT_CONFIRMATION_NUMBER: getFromSessionStorage(
      SESSION_DATA.PAYMENT_CONFIRMATION_NUMBER + '',
    ),
    PAYMENT_DATE_TIMESTAMP: getFromSessionStorage(
      SESSION_DATA.PAYMENT_DATE_TIMESTAMP + '',
    ),
    SELECTED_WALLET_FUNDING_ACCOUNT_TOKEN: getFromSessionStorage(
      SESSION_DATA.SELECTED_WALLET_FUNDING_ACCOUNT_TOKEN + '',
    ),
    SELECTED_WALLET_FUNDING_LAST_FOUR_DIGIT: getFromSessionStorage(
      SESSION_DATA.SELECTED_WALLET_FUNDING_LAST_FOUR_DIGIT + '',
    ),
    SELECTED_PAYMENT_METHOD: getFromSessionStorage(
      SESSION_DATA.SELECTED_PAYMENT_METHOD + '',
    ),
    SELECTED_SCHEDULED_TRANSACTION: getFromSessionStorage(
      SESSION_DATA.SELECTED_SCHEDULED_TRANSACTION + '',
    ),
    SELECTED_ADD_WALLET_TYPE: getFromSessionStorage(
      SESSION_DATA.SELECTED_ADD_WALLET_TYPE + '',
    ),
    SELECTED_CASE: getFromSessionStorage(SESSION_DATA.SELECTED_CASE + ''),
    WALLET_FUNDING_ACCOUNT_TOKEN: getFromSessionStorage(
      SESSION_DATA.WALLET_FUNDING_ACCOUNT_TOKEN + '',
    ),
    ACCESS_TOKEN: getFromSessionStorage(SESSION_DATA.ACCESS_TOKEN + ''),
    REFRESH_TOKEN: getFromSessionStorage(SESSION_DATA.REFRESH_TOKEN + ''),
    PKCE_VERIFIER: getFromSessionStorage(SESSION_DATA.PKCE_VERIFIER + ''),
    USER_TYPE: getFromSessionStorage(SESSION_DATA.USER_TYPE + ''),
    USER_NAME: getFromSessionStorage(SESSION_DATA.USER_NAME + ''),
    PKCE_STATE: getFromSessionStorage(SESSION_DATA.PKCE_STATE + ''),
    ACCESS_TOKEN_EXPIRY_TIME: getFromSessionStorage(
      SESSION_DATA.ACCESS_TOKEN_EXPIRY_TIME + '',
    ),
    ORIGIN: getFromSessionStorage(SESSION_DATA.ORIGIN + ''),
    ID_TOKEN: getFromSessionStorage(SESSION_DATA.ID_TOKEN + ''),
    BINDER_PAY_NOW_MEMBER_DETAILS: getFromSessionStorage(
      SESSION_DATA.BINDER_PAY_NOW_MEMBER_DETAILS + '',
    ),
    SELECTED_TAB: getFromSessionStorage(SESSION_DATA.SELECTED_TAB + ''),
    BINDER_PAYMENT_ACCOUNT: getFromSessionStorage(
      SESSION_DATA.BINDER_PAYMENT_ACCOUNT + '',
    ),
    AUTOPAY_BINDER_PAYMENT_ACCOUNT: getFromSessionStorage(
      SESSION_DATA.AUTOPAY_BINDER_PAYMENT_ACCOUNT + '',
    ),
    BINDER_PAYLATER_LOGIN_DETAILS: getFromSessionStorage(
      SESSION_DATA.BINDER_PAYLATER_LOGIN_DETAILS + '',
    ),
    BINDER_IMMEDIATE_PAYMENT_RESPONSE: getFromSessionStorage(
      SESSION_DATA.BINDER_IMMEDIATE_PAYMENT_RESPONSE + '',
    ),
    BINDER_SCHEDULE_PAYMENT_RESPONSE: getFromSessionStorage(
      SESSION_DATA.BINDER_SCHEDULE_PAYMENT_RESPONSE + '',
    ),
    BINDER_PAYMENT_DETAILS: getFromSessionStorage(
      SESSION_DATA.BINDER_PAYMENT_DETAILS + '',
    ),
    MEMBER_SUBSCRIBER_DETAILS: getFromSessionStorage(
      SESSION_DATA.MEMBER_SUBSCRIBER_DETAILS + '',
    ),
    BINDER_PAYMENT_API_TYPE: getFromSessionStorage(
      SESSION_DATA.BINDER_PAYMENT_API_TYPE + '',
    ),
    AUTOPAYMENT_DETAILS: getFromSessionStorage(
      SESSION_DATA.AUTOPAYMENT_DETAILS + '',
    ),
    SCHEDULEPAYMENTS_LIST: getFromSessionStorage(
      SESSION_DATA.SCHEDULEPAYMENTS_LIST + '',
    ),
    PAY_NOW_CONFIRMATION_NUMBER: getFromSessionStorage(
      SESSION_DATA.PAY_NOW_CONFIRMATION_NUMBER + '',
    ),
    READ_ONLY_VIEW: getFromSessionStorage(SESSION_DATA.READ_ONLY_VIEW + ''),
    LIMIT_FUNCTIONALITY: getFromSessionStorage(
      SESSION_DATA.LIMIT_FUNCTIONALITY + '',
    ),
    CAID: getFromSessionStorage(SESSION_DATA.CAID + ''),
    CONVERSION_TYPE_DETAILS: getFromSessionStorage(
      SESSION_DATA.CONVERSION_TYPE_DETAILS + '',
    ),
    SELECTED_RECENT_PAYMENT_TRACKER: getFromSessionStorage(
      SESSION_DATA.SELECTED_RECENT_PAYMENT_TRACKER + '',
    ),
    LOB: getFromSessionStorage(SESSION_DATA.LOB + ''),
    MENU_ITEMS_CONFIGURATION: getFromSessionStorage(
      SESSION_DATA.MENU_ITEMS_CONFIGURATION + '',
    ),
    POLICY_ID: getFromSessionStorage(SESSION_DATA.POLICY_ID + ''),
    PLAN_SELECTED: getFromSessionStorage(SESSION_DATA.PLAN_SELECTED + ''),
    SELECTED_PRODUCT: getFromSessionStorage(
      SESSION_DATA.SELECTED_PRODUCT + '',
    ),
    RETAIL_GOVT_DETAILS: getFromSessionStorage(
      SESSION_DATA.RETAIL_GOVT_DETAILS + '',
    ),
    HAS_GOVT_SCHEDULE_PAYMENTS_INDICATOR: getFromSessionStorage(
      SESSION_DATA.HAS_GOVT_SCHEDULE_PAYMENTS_INDICATOR + '',
    ),
    SCHEDULE_PAYMENT_COUNT: getFromSessionStorage(
      SESSION_DATA.SCHEDULE_PAYMENT_COUNT + '',
    ),
    IS_NMA_USER: getFromSessionStorage(SESSION_DATA.IS_NMA_USER + ''),
    IS_BROKER_USER: getFromSessionStorage(SESSION_DATA.IS_BROKER_USER + ''),
  };
};

interface IUpdateSessionData {
  [key: string]: {
    sessionStorageKey: string | undefined;
    value:
      | string
      | number
      | boolean
      | undefined
      | { [key: string]: any }
      | null; // added any because interface of object values differs
  };
}

export const updateSessionData = (sessionValues: IUpdateSessionData) => {
  Object.keys(sessionValues).forEach((key) => {
    if (sessionValues[key].value) {
      setToSessionStorage(
        sessionValues[key].sessionStorageKey + '',
        sessionValues[key].value,
      );
    }
  });
};

export const getPaymentDescription = (
  fiservResponse: IFiservResponse | undefined,
) => {
  let paydesc: string;
  if (
    fiservResponse?.fundingAccountValidationResult?.fundingAccount
      ?.fundingMethod === 'ACH'
  ) {
    paydesc = `${fiservResponse?.fundingAccountValidationResult?.checkValidationDetail?.fundingAccountType}${fiservResponse?.fundingAccountValidationResult?.fundingAccount?.bankAccountType}x${fiservResponse?.fundingAccountValidationResult?.fundingAccount?.fundingAccountLastFourDigit}`;
  } else {
    paydesc = `Cardx${fiservResponse?.fundingAccountValidationResult?.fundingAccount?.fundingAccountLastFourDigit}`;
  }
  return paydesc;
};

export const areValuesDefined = (
  obj: ISESSION_DATA,
  keysToCheck?: (keyof ISESSION_DATA)[],
): boolean => {
  const keys = keysToCheck || (Object.keys(obj) as (keyof ISESSION_DATA)[]);
  return keys.every((key) => obj[key] !== undefined && obj[key] !== null);
};
